import cx from "classnames";
import Image from "next/image";

import { useI18n } from "utils/with-i18n.utils";

import Avatar1 from "./Avatar1.png";
import Avatar2 from "./Avatar2.png";
import Avatar3 from "./Avatar3.png";

const AVATARS = [Avatar1, Avatar2, Avatar3];

const EMAIL = "hello@mobile.club";
const PHONE = "01 86 90 58 78";
const PHONE_HREF = "tel:+33186905878";

const TITLE_FALLBACK = "Votre service client\nest disponible :";
const EMAIL_LABEL_FALLBACK = "Par mail :";
const PHONE_LABEL_FALLBACK = "ou par téléphone :";
const AVAILABILITY_FALLBACK = "du lundi au vendredi de 9h à 18h";

type CustomerServiceProps = {
  className?: string;
};

export const CustomerService = ({ className }: CustomerServiceProps) => {
  const i18n = useI18n();

  return (
    <section
      className={cx(
        "flex flex-col gap-[18px] items-center p-6 text-center bg-white rounded-lg lg:items-start lg:text-left",
        className,
      )}
    >
      <div className="flex flex-col gap-2 items-center lg:items-start">
        <div className="flex">
          {AVATARS.map((avatar, index) => (
            <div
              key={avatar.src}
              className={cx(
                "overflow-hidden relative w-[30px] h-[30px] rounded-full bg-yellow",
                index > 0 && "-ml-2.5 shadow-[-1px_0_3px_rgba(0,0,0,0.1)]",
              )}
            >
              <Image
                src={avatar}
                alt=""
                layout="fill"
                objectFit="cover"
                sizes="30px"
              />
            </div>
          ))}
        </div>

        <h2 className="text-lg font-semibold whitespace-pre-line">
          {i18n.t(
            "footer.customerService.title",
            {},
            { fallback: TITLE_FALLBACK },
          )}
        </h2>
      </div>

      <div className="flex flex-col gap-[18px] items-center lg:items-start">
        <div className="flex flex-col gap-2 items-center lg:items-start">
          <p className="text-base font-semibold text-black/80">
            {i18n.t(
              "footer.customerService.emailLabel",
              {},
              { fallback: EMAIL_LABEL_FALLBACK },
            )}
          </p>
          <a
            href={`mailto:${EMAIL}`}
            className="text-base font-semibold text-cornflower-blue no-underline hover:underline"
          >
            {EMAIL}
          </a>
        </div>

        <div className="flex flex-col gap-2 items-center lg:items-start">
          <p className="text-base font-semibold text-black/80">
            {i18n.t(
              "footer.customerService.phoneLabel",
              {},
              { fallback: PHONE_LABEL_FALLBACK },
            )}
          </p>
          <div className="flex flex-col gap-1 items-center lg:items-start">
            <a
              href={PHONE_HREF}
              className="text-base font-semibold text-cornflower-blue no-underline hover:underline"
            >
              {PHONE}
            </a>
            <p className="flex gap-2 items-center text-sm text-black/50">
              <span className="shrink-0 w-1.5 h-1.5 bg-jade rounded-full" />
              {i18n.t(
                "footer.customerService.availability",
                {},
                { fallback: AVAILABILITY_FALLBACK },
              )}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};
